import { Accordion } from "../../accordion.js";

export default () => {
  document.querySelectorAll(".js-topic-accordion").forEach((container, i) => {
    // Initialize every accordion inside this container
    container.querySelectorAll(".js-accordion").forEach((accordionEl, j) => {
      Accordion(accordionEl, `${i}-${j}`);
    });
  });
};
